<script>
    import {polygonDeposits} from 'src/components/cabinet/#services/evmAdapter'
    import IconifyIcon from '@iconify/svelte'
    import copyIcon from '@iconify/icons-fa-solid/copy'
    import pauseIcon from '@iconify/icons-fa-solid/pause'
    import pendingIcon from '@iconify/icons-fa-solid/spinner'
    import successIcon from '@iconify/icons-fa-solid/check-circle'
    import errorIcon from '@iconify/icons-fa-solid/exclamation-circle'
    import PerPage from 'src/components/#common/pagination/PerPage.svelte'
    import Pagination from 'src/components/#common/pagination/Pagination.svelte'
    import {Table} from 'sveltestrap'
    import {copyClipboard, roundNumber} from 'src/components/#common/helpers'

    let currentPage = 0
    let perPage = 25
    let startDate
    let endDate
    let currency = 'LIS'
    let recipientAddress
    let emailAddress
    let supportId
    let maxDate = new Date()
    let dd = String(maxDate.getDate()).padStart(2, '0')
    let mm = String(maxDate.getMonth() + 1).padStart(2, '0')
    let yyyy = maxDate.getFullYear()
    maxDate = yyyy+'-'+mm+'-'+dd

    function filter() {
        polygonDeposits.reset()
        polygonDeposits.send({ data: {
            receiverId: recipientAddress,
            email: emailAddress,
            userId: supportId,
            page: currentPage + 1,
            perPage,
            startDate,
            endDate,
            currency
        }})
        $polygonDeposits.value
    }

    function reset() {
        recipientAddress = undefined
        startDate = undefined
        endDate = undefined
        emailAddress = undefined
        supportId = undefined
        currency = 'LIS'
        currentPage = 0
        filter()
    }

    $:currentPage,perPage,filter()

    async function copy(value) {
        copyClipboard(value)
    }
</script>

<div class="buttons">
    <div class="pc-line">
        <input type="text" bind:value={recipientAddress} class="form-control wallet-address" placeholder="Enter wallet">
    </div>
    <div class="pc-line">
        <select class="form-select" bind:value={currency}>
            <option value="LIS">LIS</option>
            <option value="USDT">USDT</option>
            <option value="MATIC">MATIC</option>
        </select>
    </div>
    <div class="pc-line">
        <input type="text" bind:value={supportId} class="form-control wallet-address" placeholder="Support ID">
    </div>
    <div class="pc-line">
        <input type="text" bind:value={emailAddress} class="form-control wallet-address" placeholder="Enter Email">
    </div>
    <div class="pc-line">
        <input type="date" bind:value={startDate} class="form-control" max="{maxDate}">
    </div>
    <div class="pc-line">
        <input type="date" bind:value="{endDate}" class="form-control" max="{maxDate}">
    </div>
    <div class="pc-line">
        <button class="btn btn-primary btn-filter" on:click={filter}>Filter</button>
        <button class="btn btn-secondary" on:click={reset}>Reset</button>
    </div>
</div>
{#if $polygonDeposits.hasValue}
    <PerPage
        bind:perPage={perPage}
        disabled={$polygonDeposits.loading || $polygonDeposits.loading}
        totalCount={$polygonDeposits.value.totalCount}
    />
{/if}
<div class="transactions-list">
    <Table bordered striped responsive>
        <thead>
        <tr>
            <td class="text-center">Amount</td>
            <td class="text-center">User</td>
            <td class="text-center">Wallet</td>
            <td class="text-center">On balance</td>
            <td class="text-center">On a cold wallet</td>
            <td class="text-center">Date</td>
        </tr>
        </thead>
        <tbody>
        {#if $polygonDeposits.loading}
            {#each {length:perPage} as item}
                <tr>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                </tr>
            {/each}
        {:else if $polygonDeposits.error || !$polygonDeposits.hasValue}
            <tr>
                <td class="text-center" colspan="6">
                    {#if $polygonDeposits.error}
                        {$polygonDeposits.error}
                    {:else}
                        Something went wrong. Try refreshing the page.
                    {/if}
                </td>
            </tr>
        {:else}
            {#each $polygonDeposits.value.data as {id, amount, currency, isSentToColdWallet, receiverId, sentToTransactionStatus, transactionHash, userId, createdAt}}
                <tr>
                    <td class="text-center">{roundNumber(+amount)} {currency === 'WLIS' ? 'LIS' : currency}</td>
                    <td class="text-center">
                        {#if userId}
                            <a href="profile/{userId}" class="reason" target="_blank" rel="noreferrer">{userId}</a>
                        {/if}
                    </td>
                    <td class="text-center">
                        {#if transactionHash}
                            <a href="https://nearblocks.io/txns/{transactionHash}" class="address notranslate" target="_blank" rel="noreferrer">
                                {#if receiverId.length >= 20}
                                    {receiverId.slice(0,7)}...{receiverId.slice(-7)}
                                {:else}
                                    {receiverId}
                                {/if}
                            </a>
                        {:else}
                            <a href="https://nearblocks.io/token/token.v1.realisnetwork.near?a={receiverId}" class="address notranslate" target="_blank" rel="noreferrer">
                                {#if receiverId.length >= 20}
                                    {receiverId.slice(0,7)}...{receiverId.slice(-7)}
                                {:else}
                                    {receiverId}
                                {/if}
                            </a>
                        {/if}
                        <button class="btn copy-btn" on:click={copy(receiverId)}>
                            <IconifyIcon icon={copyIcon} class="side-nav-icon"/>
                        </button>
                    </td>
                    <td class="text-center">
                        {#if sentToTransactionStatus === 'NOT_SENT'}
                            <span class="status-icon status-pending" title="Not sent">
                                <IconifyIcon icon={pauseIcon}/>
                            </span>
                        {:else if sentToTransactionStatus === 'IS_SENDING'}
                            <span class="status-icon status-pending" title="Pending">
                                <IconifyIcon icon={pendingIcon}/>
                            </span>
                        {:else if sentToTransactionStatus === 'SENT'}
                            <span class="status-icon status-success" title="Sent">
                                <IconifyIcon icon={successIcon}/>
                            </span>
                        {:else if sentToTransactionStatus === 'ERROR'}
                            <span class="status-icon status-error" title="Error">
                                <IconifyIcon icon={errorIcon}/>
                            </span>
                        {/if}
                    </td>
                    <td class="text-center">
                        {#if isSentToColdWallet === 'NOT_SENT'}
                            <span class="status-icon status-pending" title="Not sent">
                                <IconifyIcon icon={pauseIcon}/>
                            </span>
                        {:else if isSentToColdWallet === 'SENT'}
                            <span class="status-icon status-success" title="Sent">
                                <IconifyIcon icon={successIcon}/>
                            </span>
                        {:else if isSentToColdWallet === 'ERROR'}
                            <span class="status-icon status-error" title="Error">
                                <IconifyIcon icon={errorIcon}/>
                            </span>
                        {/if}
                    </td>
                    <td class="text-center">{new Date(createdAt).toLocaleString()}</td>
                </tr>
            {:else}
                <tr>
                    <td class="text-center" colspan="6">No items</td>
                </tr>
            {/each}
        {/if}
        </tbody>
    </Table>
    {#if $polygonDeposits.hasValue}
        <PerPage
            bind:perPage={perPage}
            disabled={$polygonDeposits.loading || $polygonDeposits.loading}
            totalCount={$polygonDeposits.value.totalCount}
        />
        <Pagination
            bind:currentPage={currentPage}
            totalCount={$polygonDeposits.value.totalCount}
            {perPage}
            disabled={$polygonDeposits.loading || $polygonDeposits.loading}
        />
    {/if}
</div>

<style>
    .status-icon {
        font-size: 16px;
    }

    .copy-btn {
        font-size: 14px;
        line-height: 11px;
        background: #8391a2;
        color: white;
        padding: 4px 5px;
        margin: -4px 0 -3px 4px;
        transition: .15s;
    }

    .copy-btn:hover {
        background: #768494;
    }

    .wallet-address {
        display: inline-block;
        width: auto;
    }

    .buttons {
        margin-bottom: 15px;
    }

    .buttons .btn {
        margin-left: 5px;
    }

    .transaction-loading {
        height: 24px;
        width: 100%;
        display: block;
    }

    .btn-primary.btn-filter {
        padding: 8px 20px;
    }

    input[type="date"] {
        width: auto;
        display: inline-block;
        vertical-align: top;
    }

    .btn.btn-secondary {
        padding: 10px 20px;
        font-size: 14px;
        line-height: normal;
        border: 0;
        box-shadow: none;
    }

    .btn.active {
        background: #FF5D1C;
    }

    .pc-line {
        display: inline-block;
        margin-bottom: 10px;
        vertical-align: top;
    }

    .status-success {
        color: #27AE60;
    }

    .status-pending {
        color: #ff9800;
    }

    .status-error {
        color: #da4848;
    }

    .buttons {
        margin-bottom: 15px;
    }

    .buttons .btn {
        margin-left: 5px;
    }

    .transaction-loading {
        height: 24px;
        width: 100%;
        display: block;
    }

    .btn-primary.btn-filter {
        padding: 8px 20px;
    }

    input[type="date"] {
        width: auto;
        display: inline-block;
        vertical-align: top;
    }

    .btn.btn-secondary {
        padding: 10px 20px;
        font-size: 14px;
        line-height: normal;
        border: 0;
        box-shadow: none;
    }

    .btn.active {
        background: #FF5D1C;
    }

    .pc-line {
        display: inline-block;
        margin-bottom: 10px;
    }

    @media(max-width: 767px) {
        .pc-line {
            display: block;
        }

        .pc-line .btn {
            margin-left: 0;
            width: 100%;
        }

        .btn-filter {
            margin-bottom: 10px;
        }

        .pc-line {
            display: block;
        }

        .pc-line .btn {
            margin-left: 0;
            width: 100%;
        }

        .btn-filter {
            margin-bottom: 10px;
        }
    }
</style>
